import { render, staticRenderFns } from "./system-architecture.vue?vue&type=template&id=69cdb09c&scoped=true&"
import script from "./system-architecture.vue?vue&type=script&lang=js&"
export * from "./system-architecture.vue?vue&type=script&lang=js&"
import style0 from "./system-architecture.vue?vue&type=style&index=0&id=69cdb09c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cdb09c",
  null
  
)

export default component.exports